import React from 'react';

import ListPage from '../../../sharedModules/listPage/ListPage';

const ManufacturersListPage: React.FC = () => {
  const typeOptions = [
    { label: 'Backflow Preventers', value: 'Backflow Preventer' },
    { label: 'Water Meters', value: 'Water Meter' },
    { label: 'Energy Solutions', value: 'Energy Solutions' },
  ];

  const manufacturerFilters = [
    {
      label: 'Type',
      type: 'select',
      choices: typeOptions,
      param: 'manufacturer_types_name_i_cont',
    },
  ];

  const manufacturerColumns = [
    {
      name: 'Name',
      selector: 'name',
      sortable: true,
      wrap: true,
    },
    {
      name: 'Types',
      selector: 'type_names',
      wrap: true,
    },
  ];

  let defaultFilterSetting = { manufacturer_types_name_i_cont: 'all' };

  return (
    <ListPage
      clearedFilterSetting={defaultFilterSetting}
      columns={manufacturerColumns}
      controller="manufacturers"
      defaultFilters={defaultFilterSetting}
      filterDefinitions={manufacturerFilters}
      includeFilterBar
      queryPlaceholder="Filter by name..."
      title="Manufacturers"
    />
  );
};

export default ManufacturersListPage;
